'use client';

import React, { forwardRef } from 'react';
import { clsx } from 'clsx';
import { useBuyerBrandStore } from 'app/store/brand';
import { type BasicShopUIPropTypes, type BuyerLayoutProps } from 'shop-ui/types';
import i18n from '@shared/i18n';
import './FooterKYC.scss';

interface FooterKYCProps extends BasicShopUIPropTypes, BuyerLayoutProps {
    // 自行加入其他 props
    content: string;
}

export const FooterKYC = forwardRef<HTMLDivElement, FooterKYCProps>((props, ref) => {
    const { style, className, isBuyer } = props;

    const { taxInfo } = useBuyerBrandStore();

    return (
        <div ref={ref} style={style} className={clsx('footer-kyc-area', className)}>
            <ul className="footer-kyc-area-list">
                <li className="footer-kyc-area-item">
                    {!isBuyer && (
                        <>
                            <div className="footer-kyc-area-item-label">
                                {i18n.gettext('營業名稱')}
                            </div>
                            <div className="footer-kyc-area-item-content">
                                {i18n.gettext('品牌的營業名稱')}
                            </div>
                        </>
                    )}
                    {taxInfo?.company_name && isBuyer && (
                        <>
                            <div className="footer-kyc-area-item-label">
                                {i18n.gettext('營業名稱')}
                            </div>
                            <div className="footer-kyc-area-item-content">
                                {taxInfo.company_name}
                            </div>
                        </>
                    )}
                </li>
                <li className="footer-kyc-area-item">
                    {!isBuyer && (
                        <>
                            <div className="footer-kyc-area-item-label">
                                {i18n.gettext('統一編號')}
                            </div>
                            <div className="footer-kyc-area-item-content">12345678</div>
                        </>
                    )}
                    {taxInfo?.tax_id && isBuyer && (
                        <>
                            <div className="footer-kyc-area-item-label">
                                {i18n.gettext('統一編號')}
                            </div>
                            <div className="footer-kyc-area-item-content">
                                {taxInfo.tax_id}
                            </div>
                        </>
                    )}
                </li>
            </ul>
        </div>
    );
});

FooterKYC.displayName = 'FooterKYC';
